import { createContext } from 'react';

const GtmContext = createContext({
  gtm: {},
  setGtm: (g) => {}
});

export default GtmContext;